export default "__VITE_ASSET__BrDBo8zv__"